<template>
    <b-row class="slide-body">
        <b-col cols="1">
            <router-link  :to="{name:'slide30',params:{lang:lang}}"><b-img left src="@/images/button-left.png" :title="$t('general.previous')" fluid></b-img></router-link>
        </b-col>

        <b-col cols="6">                
            <b-card> 
                <b-row align-h="center">  
                    <img src="@/images/slide31-logos.png"/>
                </b-row>
                <b-row align-h="center" class="pt-5">  
                    <h5 style="color:#4e74e0"><strong>{{ $t('slide31.text1') }}</strong></h5>
                </b-row>
                <b-row align-h="center">  
                    <h5><strong>{{ $t('slide31.text2') }}</strong></h5>
                </b-row>
                <b-row align-h="center">  
                    <h5><strong>{{ $t('slide31.text3') }}</strong></h5>
                </b-row>
                <b-row align-h="center">  
                    <h5><strong>{{ $t('slide31.text4') }}</strong></h5>
                </b-row>
                <b-row align-h="center">  
                    <h5><strong>{{ $t('slide31.text5') }}</strong></h5>
                </b-row>
                <b-row align-h="center">  
                    <h5><strong>{{ $t('slide31.text6') }}</strong></h5>
                </b-row>
            </b-card>
        </b-col>                
        <b-col cols="5">
            <b-row align-v="center" align-h="center">
                <img src="@/images/slide31-tronic.png"/>
            </b-row>
            <b-row align-v="center" align-h="center" class="pt-5" >
                <b-button variant="warning" @click="rePlay"><h2><strong>{{ $t('slide31.text7') }}</strong></h2></b-button>
            </b-row>
        </b-col>        
    </b-row>  
</template>


<script>
import {mapState} from 'vuex';

export default {
    props:['lang'],    
    computed: {
        ...mapState(['showMenu']),
    },
    methods:{
        rePlay(){
            this.$store.dispatch('updateVariable',{name: 'slide0Password',value: "-1"});
            this.$store.dispatch('updateVariable',{name: 'slide0Escola',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide0Equip',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide0Curs',value: ""});
            this.$store.dispatch('updateVariable',{name: 'solOptima',value: true});
            this.$store.dispatch('updateVariable',{name: 'slide11Piece1',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide11Piece2',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide11Piece3',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide12Process1',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide12Process2',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide12Process3',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide13Machine1',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide13Machine2',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide13Machine3',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide13Machine4',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide13Machine5',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide13Machine6',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide14Conditioners1',value: null});
            this.$store.dispatch('updateVariable',{name: 'slide14Conditioners2',value: null});
            this.$store.dispatch('updateVariable',{name: 'slide14Conditioners3',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign1',value: null});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign2',value: null});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign3',value: null});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign4',value: null});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign5',value: null});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign6',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign7',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign8',value: ""});
            this.$store.dispatch('updateVariable',{name: 'slide23EndDesign9',value: ""});
            this.$store.dispatch('updateVariable',{name: 'PuntsJoc1',value: ""});
            this.$store.dispatch('updateVariable',{name: 'elapsedTimeGame1',value: ""});
            this.$store.dispatch('updateVariable',{name: 'elapsedTimeGame2',value: ""});
            this.$store.dispatch('updateVariable',{name: 'puntsTotals',value: "0"});
            
            this.$router.push("/");            
        }
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',false);
    },
    created(){
        this.$i18n.locale=this.lang;
    }     
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        position:relative; 
        width: 100%; 
    }

    img {
        max-width: 100%;
        height: auto;
    }

</style>